/*
 * @Descripttion: 处理用户状态  ，收到消息时， 登录登出时    更新用户信息、状态等
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-11-19 16:33:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-29 19:27:06
 */
import { setCookie, removeCookie, getCookie } from '../../utils/checkCookie'
import { fromJS, Map, List } from 'immutable'
import actionTypes from '../actionTypes'
import { act } from 'react-dom/test-utils'

const defaultState = fromJS({ // 将对象转成immutable对象
    user: fromJS({
        // userName: getCookie('KEY_USERNAME'),
        // avatar: getCookie('KEY_AVATAR'),
        // userId: Number(getCookie('KEY_USERID'))
    }),  //用户信息
    loginObj: fromJS({
        login: getCookie('KEY_LOGIN_STATE') == 'true' ? true : false,
        token: getCookie("token") === "undefined" ? undefined : getCookie("token")
    }),  //登录
    registerObj: fromJS({}),
    friendList: fromJS([]),
    friendApplication: fromJS([]),
    talkList: fromJS([]),//代表了用户当前所有的会话列表，每一项代表一个会话    每个会话 包含房间号作为键值，内容包括未读消息数量、最新的信息
    activeRoom: null, //当前选择的房间  有用信息有roomId，type ,chatName其他没有用
    newGroupList: fromJS([]),//新的群组会话列表
    userMsg: fromJS(0),
    zd_user: fromJS({
    }),  //浙大相关登录信息
    ProcessProductHideAndShowFlag: false,    //控制生产定制中，检索结果贴球时进行其他框的隐藏和后续的恢复
    ProcessProduct_SourceInputHideAndShowFlag: false,    //控制生产定制中，检索结果贴球时进行其他框的隐藏和后续的恢复
})

// const defaultState = {
//     loginstate: getCookie('KEY_LOGIN_STATE')=='true'?true:false,//cookie获得的值是字符串类型的
//     userName: getCookie('KEY_USERNAME')
// }
export default (state = defaultState, action) => {
    let item
    let index
    switch (action.type) {
        case actionTypes.LoginIn:
            setCookie('KEY_LOGIN_STATE', action.data.login)
            setCookie('token', action.data.token)
            setCookie('userInfo', action.data.userInfo)
            return state.merge({
                loginObj: fromJS(action.data)
            })
        case actionTypes.SaveUser:
            // setCookie('KEY_USERNAME', action.data.userName)
            // setCookie('KEY_USERID', action.data.userId)
            // setCookie('KEY_AVATAR', action.data.avatar)
            return state.merge({
                user: fromJS(action.data)
            })
        case actionTypes.ZD_SaveUser:
            // setCookie('KEY_USERNAME', action.data.userName)
            // setCookie('KEY_USERID', action.data.userId)
            // setCookie('KEY_AVATAR', action.data.avatar)
            setCookie('zd_token', action.data.token)
            return state.merge({
                zd_user: fromJS(action.data)
            })
        case actionTypes.LoginOut:
            setCookie('KEY_LOGIN_STATE', false)
            removeCookie('token')
            removeCookie('userInfo')
            // setCookie('KEY_USERNAME', null)
            // setCookie('KEY_USERID', null)
            // setCookie('KEY_AVATAR', null)
            return state.merge({
                user: fromJS({}),
                loginObj: fromJS({}),
                friendList: fromJS([]),
                talkList: fromJS([]),
                friendApplication: fromJS([]),
                activeRoom: null,
            })
        case actionTypes.ChangeRoom:
            return state.merge({
                activeRoom: action.data.roomInfo,
                talkList: state.get('talkList').map((item) => {
                    if (action.data.roomInfo && (item.get('roomId') === action.data.roomInfo.roomId)) {
                        return item.set('unReadMsg', 0)
                    } else {
                        return item.set('unReadMsg', item.get('unReadMsg'))
                    }
                })
            })
        // case actionTypes.Register:
        //     return state.merge({
        //         registerObj: fromJS(action.data)
        //     })
        case actionTypes.GetFriendList:
            return state.merge({
                friendList: fromJS(action.data)
            })
        case actionTypes.GetFriendApplication:
            return state.merge({
                friendApplication: fromJS(action.data)
            })
        case actionTypes.AddTalkList:
            // debugger
            // let a = state.get('talkList')
            let has = state.get('talkList').find(item => {
                return item.get('roomId') === action.data.roomId
            })

            let i = state.get('talkList').indexOf(has)
            if (has) {
                return state.merge({
                    talkList: state.get('talkList').splice(i, 1, fromJS(action.data))
                })
                // return state
            } else {
                return state.merge({
                    talkList: state.get('talkList').push(fromJS(action.data))
                })
            }
        case actionTypes.ResetTalkList:
            return state.merge({ 'talkList': fromJS([]) })
        case actionTypes.ChangeActiveRoomName:
            // debugger
            // let b = state.get('newGroupList')
            let item = state.get('newGroupList').find(item => {
                return item.roomId === action.data.roomId
            })
            let index = state.get('newGroupList').indexOf(item)
            if (item) {
                return state.merge({
                    newGroupList: state.get('newGroupList').splice(index, 1, action.data)
                })
                // return state
            } else {
                return state.merge({
                    newGroupList: state.get('newGroupList').push(action.data)
                })
            }
        case actionTypes.DeleteTalkList:
            // debugger
            // let a  = state.get('talkList')
            let deleteTalkList = state.get('talkList').find((item) => {
                return item.get('serial') === action.data.serial
            })

            let deleteTalkListIndex = state.get('talkList').indexOf(deleteTalkList)
            return state.merge({
                talkList: state.get('talkList').splice(deleteTalkListIndex, 1)
            })
        case actionTypes.DeleteFriend:
            // debugger
            let a = state.get('friendList')
            // 好像这个函数并没有什么卵用，具体原因不知道，后面的人看到研究研究吧！！！！
            // 小爷研究出来了，原写法是：
            // return item.get('friendInfo').get('userId') === action.data.userId
            // 多解析了一层
            let deleteFriend = state.get('friendList').find((item) => {
                return item.get('userId') === action.data.userId
                //    console.log(item)
            })

            let deleteFriendIndex = state.get('friendList').indexOf(deleteFriend)

            return state.merge({
                friendList: state.get('friendList').splice(deleteFriendIndex, 1)
            })
        case actionTypes.AddRoomLastMsg:
            // debugger
            return state.merge({
                talkList: state.get('talkList').map((item) => {
                    if (item.get('roomId') === action.data.roomId) {
                        return item.set('lastMsg', fromJS(action.data.lastMsg)).set('lastMsgTime', fromJS(action.data.lastMsgTime)).set('messageId', fromJS(action.data.messageId))
                    } else {
                        return item.set('lastMsg', item.get('lastMsg'))
                    }
                })
            })
        case actionTypes.AddRoomUnReadMsg://来新消息了  时会调用    增加未读消息数目    调整顺序
            let tl = state.get('talkList').toJS()
            tl.map((room, index) => {
                if (room.roomId == action.data.roomId) {
                    tl.unshift(tl.splice(index, 1)[0]);
                }
            })

            state = state.merge({
                talkList: fromJS(tl),
            })

            if (state.get('activeRoom') && (state.get('activeRoom').roomId === action.data.roomId)) {
                return state
            }
            return state.merge({
                talkList: state.get('talkList').map((item) => {
                    if (item.get('roomId') === action.data.roomId) {
                        return item.set('unReadMsg', item.get('unReadMsg') ? 1 + item.get('unReadMsg') : 1)//未读消息 加加
                    } else {
                        return item.set('unReadMsg', item.get('unReadMsg'))
                    }
                })
            })

        case actionTypes.DeleteRoomUnReadMsg://清除未读消息数目
            return state.merge({
                talkList: state.get('talkList').map((item) => {
                    if (item.get('roomId') === action.data.roomId) {
                        return item.set('unReadMsg', 0)
                    } else {
                        return item.set('unReadMsg', item.get('unReadMsg'))
                    }
                })
            })
        case actionTypes.ProcessProductHideAndShow://控制生产定制中，检索结果贴球时进行其他框的隐藏和后续的恢复
            return state.merge({ ProcessProductHideAndShowFlag: !state.get('ProcessProductHideAndShowFlag') })
        case actionTypes.ProcessProduct_SourceInputHideAndShowFlag://控制生产定制中，检索结果贴球时进行其他框的隐藏和后续的恢复
            return state.merge({ ProcessProduct_SourceInputHideAndShowFlag: !state.get('ProcessProduct_SourceInputHideAndShowFlag') })
        case actionTypes.SetUserMsg:
            return state.merge({ userMsg: action.userMsg })
        default:
            break;
    }
    return state
}

